import { useQuery } from '@tanstack/react-query';
import { EquipmentUsage, EquipmentUsageFilterInput } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const ALL_EQUIPMENT_USAGE_HISTORY_QUERY_KEY = ['allEquipmentUsageHistory'];

export const useAllEquipmentUsageHistory = (filter?: EquipmentUsageFilterInput) => {
  return useQuery<EquipmentUsage[], Error>({
    queryKey: [
      ...ALL_EQUIPMENT_USAGE_HISTORY_QUERY_KEY,
      filter?.warehouseId,
      filter?.categoryId,
      filter?.assetId,
      filter?.taskId,
      filter?.startDate,
      filter?.endDate,
      filter?.limit,
    ],
    queryFn: async () => {
      const usageHistory = await warehouseService.getAllEquipmentUsageHistory(filter);
      return usageHistory || [];
    },
    staleTime: 2 * 60 * 1000,
  });
};

export default useAllEquipmentUsageHistory;
